<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage notranslate">({{locale.required}})</span>
    </div>
    <div
      v-for="(option, index) in itemSetting.action.item"
      :lang="lang"
      :key="index"
      :class="{
        quantityOption: hasQuantity,
        isChecked: value === `${index}_${option.value}`
      }"
      class="listItem checkbox radio">
      <input type="radio"
        :name="`radio_${id}`"
        :id="`radio_${id}_${index}`"
        :value="option.id || `${index}_${option.value}`"
        v-model="value"
        @change="changeValue(option)">
      <label :for="`radio_${id}_${index}`" :style="valueStyle">
        <span v-html="option.label[lang]"></span>
        <span class="optionPrice priceDpBoard notranslate">{{priceFormat(option.price)}}</span>
      </label>
      <!-- 옵션별 수량 설정 -->
      <div
        v-if="hasQuantity"
        class="quantity">
        <button
          type="button"
          class="btnQuantity"
          data-quantity="minus"
          :disabled="Number(option.quantity) === itemSetting.action.min || value !== `${index}_${option.value}`"
          @click="dec(option, index)">-</button>
        <input type="text"
          class="inputQuantity"
          :placeholder="`${itemSetting.action.min} ~ ${itemSetting.action.max}`"
          :value="option.quantity"
          disabled>
        <button
          type="button"
          class="btnQuantity"
          data-quantity="plus"
          :disabled="Number(option.quantity) === itemSetting.action.max || itemSetting.action.min >= itemSetting.action.max || value !== `${index}_${option.value}`"
          @click="inc(option, index)">+</button>
      </div>
      <!-- //옵션별 수량 설정 -->
      <!-- 옵션별 선택에 따른 추가옵션(서브) -->
      <div v-if="option.value === value.split('_').splice(1).join('') && getSubOption(option)" class="break">
        <!-- <button
          type="button"
          class="btn btnWhite sizeXs mt5"
          @click="setSubOption(option)">
          {{option.label[lang]}} > {{locale.page_suboption}}
        </button> -->
        <div v-for="sub in getSubOption(option)"
          :key="sub.id"
          class="subOption">
          <component
            :is="sub.name.replace(/\b\w/g, l => l.toUpperCase())"
            :locale="locale"
            :lang="lang"
            :id="sub.id"
            :itemSetting="sub.setting"
            :subOption="subOption"
            :isSub="true" />
        </div>
      </div>
      <!-- //옵션별 선택에 따른 추가옵션(서브) -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import regExp from '@/common/regExp'
import Input from './Input.vue'
import Checkbox from './Checkbox.vue'
import Radio from './Radio.vue'
import Select from './Select.vue'

export default {
  name: 'Radio',
  props: [
    'pageId',
    'id',
    'itemSetting',
    'lang',
    'locale',
    'isSub',
    'subOption',
    'storageData',
    'getPage',
    'getSubmitData',
    'priceOption',
    'hasPrice'
  ],
  components: {
    Input,
    Checkbox,
    Radio,
    Select
  },
  computed: {
    ...mapGetters({
      price: 'page/getPrice'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    hasQuantity () {
      return this.itemSetting.action.optionQuantity
    },
    value: {
      get () {
        const data = this.getSubmitData && this.getSubmitData.find(x => x.id === this.id) ? this.getSubmitData.find(x => x.id === this.id).value : ''
        return data
      },
      set (value) {
        this.setSubmitData(value)
      }
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    },
    moduleAll () {
      return this.getPage
    },
    subOptions () {
      const moduleAll = this.moduleAll.module
      const sub = this.getSubmitData && this.getSubmitData.find(x => x.id === this.id) ? this.getSubmitData.find(x => x.id === this.id).subOption : []
      return sub && moduleAll
        ? moduleAll.filter(x => sub.map(s => s.subOption).includes(x.id))
        : null
    }
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        if (value) {
          this.setSubmitData(value)
        }
      }
    },
    hasPrice (hasPrice) {
      if (hasPrice) {
        if (this.itemSetting.action.hasDefault && !!this.itemSetting.action.defaultValue && this.itemSetting.action.defaultValue !== '') {
          const dValue = this.itemSetting.action.defaultValue.split('_').splice(1).join('')
          const item = this.itemSetting.action.item
          const setPriceOption = this.priceOption
          item.forEach(function (option) {
            if (option.value === dValue) {
              setPriceOption(option)
            }
          })
        }
      }
    }
  },
  data () {
    let rLang = this.lang
    return {
      component: null,
      message: 'is required',
      rLang
    }
  },
  methods: {
    setSubmitData (value) {
      const passed = !this.itemSetting.action.isRequired ? null : value !== ''
      const options = this.itemSetting.action.item
      const data = {
        id: this.id,
        value: value,
        valueOption: options,
        passed: passed
      }
      this.$emit('setValue', data)
    },
    changeValue (option) {
      this.setPriceOption(option)
    },
    priceFormat (price) {
      const code = this.currency
      return price ? regExp.priceFormat(price, code) : ''
    },
    setPriceOption (option) {
      const lang = this.lang
      const hasQuantity = this.hasQuantity
      const p = regExp.uncomma(option.price)
      const price = typeof (p) === 'undefined' || p === '' ? 0 : Number(p.replace(/\(|\)|\+/g, ''))
      const value = this.value.split('_').splice(1).join('')
      const data = {
        id: this.id,
        itemLabel: this.itemSetting.action.labelValue,
        label: option.label[lang],
        price: price,
        quantity: hasQuantity ? option.quantity : null,
        ...this.subOptions && {
          subOptionList: this.subOptions.map(x => x.id),
          ...this.subOption.find(x => x.parentValue === value) && {
            subOptionValue: this.subOption.find(x => x.parentValue === value).child
          }
        },
        ...this.isSub && {
          isSub: this.isSub,
          parentOption: this.itemSetting.action.parentOption
        }
      }
      this.$emit('setPriceOption', data)
    },
    inc (option, i) {
      this.itemSetting.action.item[i].quantity++
      // this.priceOption(option, i)
      const data = {
        id: this.id,
        quantity: option.quantity
      }
      this.$emit('updateOption', data)
    },
    dec (option, i) {
      this.itemSetting.action.item[i].quantity--
      // this.priceOption(option, i)
      const data = {
        id: this.id,
        quantity: option.quantity
      }
      this.$emit('updateOption', data)
    },
    getSubOption (option) {
      const mods = this.subOptions ? this.subOptions.filter(x => x.id === option.subOption) : null
      return mods
    },
    setEmitValue (data) {
      this.$emit('setValue', data)
    }
  }
}
</script>
